/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { GetTransportTypesResponseJson } from './get-transport-types-response-json';
import { GetTransportTypesResult } from '../results/get-transport-types-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';
import { TransportTypeDto } from '../models/transport-type-dto';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class GetTransportTypesResponse extends ResponseWithErrorGeneric<GetTransportTypesResponseJson, GetTransportTypesResult> implements IResponseWithErrorGeneric<GetTransportTypesResult> {
  public transportTypes: TransportTypeDto[];

  //<custom-body>
  constructor(response: HttpResponse<GetTransportTypesResponse>) {
    super(response, GetTransportTypesResult.Error);
    if (this.result !== GetTransportTypesResult.Success) {
      return;
    }

    if (this.body.transportTypes != null)
      this.transportTypes = this.body.transportTypes;
  }
  //</custom-body>
}
